import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import QuantityControl from '../helper/QuantityControl'
import { useTranslation } from 'react-i18next'
import { useCart, useCartTotal, useCartDiscount } from '../stores/cartStore'
import { useMoney } from '../stores/currenciesStore'

const CartSection = () => {

    const {t} = useTranslation()

    const {items, isLoading, removeFromCart, updateQuantity, fetchBestDiscount} = useCart()
    
    const { 
        subtotalFormatted, 
        discount, 
        discountFormatted, 
        totalFormatted, 
        isDiscountLoading 
    } = useCartDiscount()
    
    const {money} = useMoney()
    const initialFetchDone = useRef(false);

    // Fetch the best discount when component mounts or items change,
    // but only if we haven't done the initial fetch before
    useEffect(() => {
        if (items?.length > 0 && !initialFetchDone.current) {
            fetchBestDiscount();
            initialFetchDone.current = true;
        }
    }, [items]);

    const handleQuantityChange = async (productId, newQuantity) => {
        try {
            await updateQuantity(productId, newQuantity);
            return true
        } catch (error) {
            console.error('Error updating quantity:', error);
            return false
        }
    };

    if (!items?.length) {
        return (
            <section className="cart py-80">
                <div className="container container-lg">
                    <div className="py-48 text-center border border-gray-100 rounded-8">
                        <h3 className="mb-16">{t("cart.empty")}</h3>
                        <Link to="/shop" className="px-32 btn btn-main py-18 rounded-8">
                            {t("cart.continue_shopping")}
                        </Link>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <section className="cart py-80">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xl-9 col-lg-8">
                        <div className="px-40 py-48 border border-gray-100 cart-table rounded-8">
                            <div className="overflow-x-auto scroll-sm scroll-sm-horizontal">
                                <table className="table style-three">
                                    <thead>
                                        <tr>
                                            <th className="mb-0 text-lg h6 fw-bold">{t("cart.delete")}</th>
                                            <th className="mb-0 text-lg h6 fw-bold">{t("cart.product_name")}</th>
                                            <th className="mb-0 text-lg h6 fw-bold">{t("cart.price")}</th>
                                            <th className="mb-0 text-lg h6 fw-bold">{t("cart.quantity")}</th>
                                            <th className="mb-0 text-lg h6 fw-bold">Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            items && items.map((item) => {
                                                return (
                                                    <tr key={item.product.id}>
                                                        <td>
                                                            <button
                                                                onClick={() => removeFromCart(item.product.id)}
                                                                type="button"
                                                                className="gap-12 remove-tr-btn flex-align hover-text-danger-600"
                                                            >
                                                                <i className="text-2xl ph ph-x-circle d-flex" />
                                                                {t("cart.delete")}
                                                            </button>
                                                        </td>
                                                        <td>
                                                            <div className="gap-24 table-product d-flex align-items-center">
                                                                <Link
                                                                    to={`/products/${item.product.slug}`}
                                                                    className="border border-gray-100 table-product__thumb !tw-max-w-[100px] rounded-8 flex-center "
                                                                >
                                                                    <img
                                                                        src={item.product?.images?.length > 0 ? item.product.images[0] : ''}
                                                                        alt=""
                                                                        className='tw-object-contain tw-w-full tw-h-full !tw-max-w-full'
                                                                    />
                                                                </Link>
                                                                <div className="table-product__content !tw-max-w-[200px] text-start">
                                                                    <h6 className="mb-8 text-lg title fw-semibold">
                                                                        <Link
                                                                            to={`/products/${item.product.slug}`}
                                                                            className="link"
                                                                            tabIndex={0}
                                                                        >
                                                                            {item.product?.name}
                                                                        </Link>
                                                                    </h6>
                                                                    {/* <div className="gap-16 flex-align">
                                                                        <Link
                                                                            to="/cart"
                                                                            className="gap-8 px-8 text-sm product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-7 rounded-8 flex-center fw-medium"
                                                                        >
                                                                            Camera
                                                                        </Link>
                                                                        <Link
                                                                            to="/cart"
                                                                            className="gap-8 px-8 text-sm product-card__cart btn bg-gray-50 text-heading hover-bg-main-600 hover-text-white py-7 rounded-8 flex-center fw-medium"
                                                                        >
                                                                            Videos
                                                                        </Link>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className="mb-0 text-lg h6 fw-semibold">{money(item.product?.computed_price || 0)}</span>
                                                        </td>
                                                        <td>
                                                            <QuantityControl 
                                                                initialQuantity={item.quantity} 
                                                                onQuantityChange={(newQuantity) => handleQuantityChange(item.product.id, newQuantity)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <span className="mb-0 text-lg h6 fw-semibold">{money((item.product?.computed_price || 0) * item.quantity)}</span>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="flex-wrap gap-16 mt-16 flex-between">
                                <div className="gap-16 flex-align">
                                    <input
                                        type="text"
                                        className="common-input"
                                        placeholder="Coupon Code"
                                    />
                                    <button
                                        type="submit"
                                        className="btn btn-main py-18 w-100 rounded-8"
                                    >
                                        Apply Coupon
                                    </button>
                                </div>
                                <button
                                    type="submit"
                                    className="text-lg text-gray-500 hover-text-main-600"
                                >
                                    Update Cart
                                </button>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4">
                        <div className="px-24 py-40 border border-gray-100 cart-sidebar rounded-8">
                            <h6 className="mb-32 text-xl">{t("cart.cart_totals")}</h6>
                            <div className="p-24 bg-color-three rounded-8">
                                <div className="gap-8 flex-between">
                                    <span className="text-gray-900 font-heading-two">{t("cart.subtotal")}</span>
                                    <span className="text-gray-900 fw-semibold">{subtotalFormatted}</span>
                                </div>
                                {discount && discount.amount > 0 && (
                                    <div className="gap-8 mt-8 flex-between">
                                        <span className="text-gray-900 font-heading-two d-flex align-items-center">
                                            {t("cart.discount")}
                                        </span>
                                        <span className="text-main-two-600 fw-semibold">-{discountFormatted}</span>
                                    </div>
                                )}
                                
                                {isDiscountLoading && (
                                    <div className="gap-8 mt-8 d-flex align-items-center">
                                        <span className="text-gray-500 font-heading-two">{t("cart.checking_discounts")}</span>
                                        <div className="spinner-border spinner-border-sm text-main-two-600" role="status">
                                            <span className="visually-hidden">{t('common.loading')}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="p-24 mt-24 bg-color-three rounded-8">
                                <div className="gap-8 flex-between">
                                    <span className="text-xl text-gray-900 fw-semibold">Total</span>
                                    <span className="text-xl text-gray-900 fw-semibold">{totalFormatted}</span>
                                </div>
                                
                                {discount && discount.amount > 0 && (
                                    <div className="p-12 mt-8 text-center border border-main-two-600 rounded-8">
                                        <span className="text-main-two-600 fw-semibold">
                                            {discount.discount.description || t("cart.discount_applied")}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <Link
                                to="/checkout"
                                className="mt-40 btn btn-main py-18 w-100 rounded-8"
                            >
                                {t("cart.proceed_to_checkout")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default CartSection